'use strict';

import { Entity } from '../Entity';
import { App } from '../App';
import { User } from './User';
import { UserIntegrationProvider } from '../User/UserIntegrationProvider';

export class UserVoipExtension extends Entity {
  protected id;
  protected user;
  protected provider;
  protected extensionNumber;
  protected extensionId;
  protected extensionName;

  constructor() {
    super();
  }

  public hydrate(data: any) {
    this.id = data.id;
    this.extensionNumber = data.extensionNumber;
    this.extensionId = data.extensionId;
    this.extensionName = data.extensionName;

    if (data.user) {
      const user = new User();

      user.hydrate(data.user);

      this.user = user;
    }

    if (data.provider) {
      const provider = new UserIntegrationProvider();

      provider.hydrate(data.provider);

      this.provider = provider;
    }
  }

  public getId() {
    return this.id;
  }

  public getExtensionNumber() {
    return this.extensionNumber;
  }

  public getExtensionId() {
    return this.extensionId;
  }

  public getExtensionName() {
    return this.extensionName;
  }
}
